module.exports = __webpack_public_path__ + "img/number.84b39c6f.svg";